export const TEST_IDS = {
  APP_TILE: 'app-tile',
  FILTERS_LINK: 'filters-link',
  FACET_DROPDOWN: 'facet-dropdown',
  FACET_DROPDOWN_TRIGGER: 'facet-dropdown--trigger',
  FILTER_SIDEBAR_ITEM: 'filter-sidebar-item',
  FACET_CHECKBOX_GROUP: 'facet-checkbox-group'
};